<template>
  <div v-if="isKidsTierSupport" class="select-children-age">
    <div class="select-children-age__title">
      {{ $t("booking.child") }} {{ childIndex + 1 }}
    </div>
    <div
      id="tooltip-1"
      ref="selectChildrenAge"
      class="select-children-age__age-dropdown"
      :class="{ error: ageError && children.age === 'Select Tier' }"
      @click="$_onClick"
    >
      <AppSelectDesktop
        :list-options="listCode"
        class="select-children-age__age-dropdown__desktop"
        @input="$_getChildAge"
        :is-disable="isDisableSwitch"
        v-model="childrenAge.age"
      />

      <select
        id=""
        :value="`${childrenAge.age}`"
        name="selectMobile"
        @change="$_getChildAgeMobile($event.target.value)"
      >
        <option :value="0">{{ text }}</option>
        <option v-for="(item, index) in 12" :key="index" :value="item">
          {{ item }}
        </option>
      </select>
      <span>歳</span>
    </div>
    <div
      v-if="!isBedOptionDisabled"
      class="select-children-age__switch"
      @click="$_clickSwitch"
    >
      <AppToggleSwitch
        v-model="childrenAge.bed"
        @input="$_onSelectBed"
        :is-disable="isDisableSwitch"
      />
      <div class="select-children-age__switch__label">
        {{ childrenAge.bed ? $t("booking.with_bed") : $t("booking.no_bed") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AppSelectDesktop from "../app-select-desktop/AppSelectDesktop.vue";
import AppToggleSwitch from "../app-toggle-switch/AppToggleSwitch.vue";

export default {
  name: "ChildAgeSelect",
  components: {
    AppSelectDesktop,
    AppToggleSwitch,
  },
  props: {
    children: {
      type: Object,
      default: () => {},
    },
    childIndex: {
      type: Number,
      default: () => 0,
    },
    isShowAgeSelect: {
      type: Boolean,
    },
    childAgeError: {
      type: Boolean,
    },
  },
  data() {
    return {
      childrenAge: this.children,
      ageSelect: this.children.age,
      ageError: this.childAgeError,
      text: "< 1",
    };
  },
  computed: {
    ...mapState({
      roomActive: (state) => state.currentRoomActive,
    }),
    ...mapGetters({
      isKidsTierSupport: "isKidTiersSupport",
      roomList: "roomList",
      isBedOptionDisabled: "isBedOptionDisabled",
    }),

    listCode() {
      const listAge = [{ text: "< 1", value: 0 }];
      for (let age = 1; age <= 12; age++) {
        listAge.push({
          text: age,
          value: age,
        });
      }

      return listAge;
    },

    isDisableSwitch() {
      return this.roomList.length > 1 && this.roomActive !== 0;
    },
  },
  watch: {
    children(children) {
      this.childrenAge = children;
      this.ageSelect = children.age;
    },
    childAgeError(error) {
      this.ageError = error;
    },
  },
  methods: {
    $_getChildAge(code) {
      this.$emit("on:changeAge", code);
    },

    $_getChildAgeMobile(code) {
      this.$emit("on:changeAge", code);
    },

    $_onClick() {
      const childAgePossition = this.$refs.selectChildrenAge.offsetTop;
      this.$emit("on:fixScrolling", childAgePossition);
    },

    $_onSelectBed(value) {
      this.$emit("on:changeBed", value);
    },

    $_clickSwitch() {
      this.$emit("on:clickBedSwitch");
    },
  },
};
</script>

<style lang="scss" scoped>
.select-children-age {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 30px;
  }
  @include min-sm {
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 25px;
    }
  }

  &__title {
    text-align: left;
    flex-grow: 1;
  }

  select[name="selectMobile"] {
    border: 1px solid #dddee0;
    background: white;
    padding: 7px 15px;
    outline: none;
    height: 40px;
    border-radius: 3px;

    @include min-sm {
      display: none;
    }

    &::-ms-expand {
      display: none;
    }

    option {
      width: 100%;

      // &:first-child {
      //   display: none;
      // }
    }
  }

  &__age-dropdown {
    width: 100px;
    display: flex;
    align-items: center;
    span {
      margin-left: 10px;
    }
    &__desktop {
      display: none;
      @include min-sm {
        display: block;
      }
    }
  }

  &__switch {
    margin-top: 5px;
    margin-left: 10px;
    &__label {
      font-size: 12px;
      text-align: center;
      margin-top: -4px;
      width: 60px;
    }
  }

  .error {
    border: 2px solid red;
    border-radius: 3px;
  }
}
</style>
